import React, { useState } from 'react';
import { useQueryClient, useMutation, useQuery } from 'react-query';
import { createComment, getComments } from '../../utils/api';
import { Box, Textarea, Button } from '@chakra-ui/react'; // Import Chakra UI components

const CommentSection = () => {
  const [newComment, setNewComment] = useState('');
  const queryClient = useQueryClient();
  const [numCommentsToShow, setNumCommentsToShow] = useState(3); // State to manage the number of comments to show

  const createCommentMutation = useMutation(createComment); // Use the API function for creating a comment

  const { data: comments, refetch } = useQuery('comments', getComments); // Use the API function for fetching comments

  const handleCommentChange = (event) => {
    setNewComment(event.target.value);
  };

  const handleSubmitComment = async (event) => {
    event.preventDefault();

    try {
      await createCommentMutation.mutateAsync(newComment);
      setNewComment('');

      queryClient.invalidateQueries('comments');
    } catch (error) {
      console.error('Error posting comment:', error);
    }
  };

  const handleSeeMoreComments = () => {
    // Show 5 more comments when the "see more" button is clicked
    setNumCommentsToShow((prevNumComments) => prevNumComments + 3);
  };

  return (
 <div className="max-w-xl mx-auto pb-20 lg:pb-14 px-4 lg:px-0">
     <Box>
      <h1 className="text-slate-300 my-2">Provide Your Feedback</h1>
      <form onSubmit={handleSubmitComment}>
        <Textarea
        required
          value={newComment}
          onChange={handleCommentChange}
          placeholder="Write your comment..."
        />
        <button type="submit" className='bg-primary mt-2 mb-9 p-2 rounded-sm text-accent font-medium'>
          Post Comment
        </button>
      </form>
      <div>
        <h2>Comments</h2>
        {comments?.slice(0, numCommentsToShow).map((comment) => (
          <Box key={comment._id} borderWidth="1px" p="4" borderRadius="md" mb="4">
            <p>{comment.content}</p>
            <small>{new Date(comment.createdAt).toLocaleString()}</small>
          </Box>
        ))}
        {comments && comments.length > numCommentsToShow && (
          <div className="cursor-pointer pb-6" onClick={handleSeeMoreComments} >
            See More
          </div>
        )}
      </div>
    </Box>
 </div>
  );
};

export default CommentSection;
